// extracted by mini-css-extract-plugin
module.exports = {"followSearchResultsNavigation__item":"followSearchResultsNavigation__item","is_active":"is_active","Icon-module_icon__2DRl1":"Icon-module_icon__2DRl1"};